import { useMemo } from 'react';
import List from '@components/content/List';
import NoData from '@components/content/NoData';
import { setZeroPad } from '@utils/index';
import { useOption } from '@hooks/useOption';
import type { IDataByDateMap, ISetDataItem, IDataMap, IDateObj, IL10n } from '@type/index';

interface IContentProps {
  selectedDate: IDateObj;
  isScheduleSuccess: boolean;
  dataMap: IDataMap;
  dataByDateMap: IDataByDateMap;
  l10n: IL10n;
}

// 콘텐츠 데이터 추출
const getContentData = (selectedDate: IDateObj, dataMap: IDataMap, dataByDateMap: IDataByDateMap) => {
  if (!dataMap || !selectedDate || !dataByDateMap) {
    return null;
  }

  const { year, month, date } = selectedDate || {};
  const dataByDate = year && month && date && dataByDateMap[year] && dataByDateMap[year][month - 1][date - 1];
  const idSet = new Set();
  let contentData: ISetDataItem[][] = [];

  if (Array.isArray(dataByDate) && dataByDate?.length > 0) {
    dataByDate?.forEach((item) => {
      const id = item?.split('-')[0];
      idSet?.add(id);
    });

    idSet?.forEach((id) => {
      const filterItem = dataByDate?.filter((item) => item?.includes(id as string));
      const data = filterItem
        ?.map((v) => dataMap[v])
        ?.sort(
          (a, b) =>
            (typeof a?.order === 'number' ? a?.order : Infinity) - (typeof b?.order === 'number' ? b?.order : Infinity),
        ); // order 값이 없는 경우 맨 뒤로 보냄
      contentData.push(data as ISetDataItem[]);
    });
  }

  return contentData;
};

const Content = (props: IContentProps) => {
  const { selectedDate, isScheduleSuccess, dataMap, dataByDateMap, l10n } = props || {};
  const { serviceAlias } = useOption() || {};
  const contentData = useMemo(
    () => getContentData(selectedDate, dataMap, dataByDateMap),
    [selectedDate, dataMap, dataByDateMap],
  );

  return (
    <section className="schedule-content-wrap">
      <div className="schedule-content">
        <h1 className="schedule-content-title">
          <strong>
            {setZeroPad(selectedDate?.month)}.{setZeroPad(selectedDate?.date)}.
          </strong>{' '}
          {l10n?.content[`${serviceAlias}Title`] || ''}
        </h1>
        {isScheduleSuccess && Array.isArray(contentData) && contentData?.length > 0 ? (
          <List contentData={contentData} />
        ) : (
          <NoData l10n={l10n} />
        )}
      </div>
    </section>
  );
};

export default Content;
